/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { NotificationsValidationError } from './NotificationsValidationError';
import {
    NotificationsValidationErrorFromJSON,
    NotificationsValidationErrorFromJSONTyped,
    NotificationsValidationErrorToJSON,
} from './NotificationsValidationError';

/**
 * 
 * @export
 * @interface NotificationsHTTPValidationError
 */
export interface NotificationsHTTPValidationError {
    /**
     * 
     * @type {Array<NotificationsValidationError>}
     * @memberof NotificationsHTTPValidationError
     */
    detail?: Array<NotificationsValidationError>;
}

/**
 * Check if a given object implements the NotificationsHTTPValidationError interface.
 */
export function instanceOfNotificationsHTTPValidationError(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function NotificationsHTTPValidationErrorFromJSON(json: any): NotificationsHTTPValidationError {
    return NotificationsHTTPValidationErrorFromJSONTyped(json, false);
}

export function NotificationsHTTPValidationErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationsHTTPValidationError {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'detail': !exists(json, 'detail') ? undefined : ((json['detail'] as Array<any>).map(NotificationsValidationErrorFromJSON)),
    };
}

export function NotificationsHTTPValidationErrorToJSON(value?: NotificationsHTTPValidationError | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'detail': value.detail === undefined ? undefined : ((value.detail as Array<any>).map(NotificationsValidationErrorToJSON)),
    };
}

